import { memo, useEffect, useMemo, useState } from "react";
import BlogCard from "./card";
import Navigator from "../../component/navigator";
import { getBlogList } from "../../api";
import { BlogListItem } from "../../types";
import styles from "./index.module.scss";
import { Button, Search, Loading } from "@quark/design";
import { useDebounceEffect } from "ahooks";
import Footer from "../../component/footer";
import useDocumentTitle from "../../hooks/use-document-title";

const CourseList = () => {
  const [search, setSearch] = useState("");
  const [list, setList] = useState<BlogListItem[]>([]);
  const [loadedIdMap, setLoadedIdMap] = useState<{ [id: number]: true }>({});
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasNext, setHasNext] = useState(false);
  const firstBlog = useMemo<BlogListItem | null>(() => {
    return list[0] || null;
  }, [list]);
  const restList = useMemo<BlogListItem[]>(() => {
    const [, ...rest] = list;
    return rest;
  }, [list]);

  useDocumentTitle("博客列表");

  const loadMore = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    sessionStorage.setItem("scrollPosition", String(window.pageYOffset));
    const pageSize = list.length > 0 ? 9 : 10;
    console.log(pageSize);
    getBlogList({ page, page_size: pageSize, search })
      .then(({ next, results }) => {
        setHasNext(!!next);
        // 去重，避免下一页含有上一页已加载的card
        const filterList = results.filter((r) => !loadedIdMap[r.id]);
        setList([...list, ...filterList]);
        const newLoadedIdMap = Object.assign(
          {},
          loadedIdMap,
          ...filterList.map((r) => ({ [r.id]: true }))
        );
        setLoadedIdMap(newLoadedIdMap);
        setPage(page + 1);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const searchChange = (val: string) => {
    setSearch(val);
    setPage(1);
    setList([]);
    setLoadedIdMap({});
  };

  useEffect(() => {
    const scrollPosition = sessionStorage.getItem("scrollPosition");
    if (scrollPosition) {
      window.scrollTo(0, parseInt(scrollPosition, 10));
      sessionStorage.removeItem("scrollPosition");
    }
  }, [list]);

  useDebounceEffect(() => {
    loadMore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    loadMore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className={styles.container}>
        <Navigator activeKey="blog" />
        <div className={styles.content}>
          <Search
            value={search}
            onChange={(e: { target: { value: string } }) =>
              searchChange(e.target.value)
            }
            onClear={() => searchChange("")}
            style={{ width: "100%" }}
            placeholder="搜索文章、博客"
          />
          {!!firstBlog && <BlogCard long dataSource={firstBlog} />}
        </div>
        <div className={styles.list}>
          {restList.map((blog) => (
            <BlogCard dataSource={blog} key={blog.id} />
          ))}
        </div>
        {loading && <Loading style={{ height: "80vh" }} />}
        {!loading && hasNext && (
          <div className={styles["load-more"]}>
            <Button onClick={loadMore}>加载更多</Button>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default memo(CourseList, () => true);
